import { Modal } from 'bootstrap'
const { InfoWindow } = await google.maps.importLibrary('maps')

export default {
  data() {
    return {
      userCoords: {
        latitude: null,
        longitude: null,
      },
      mapInfoWindow: null,
      profileWinery: {},
      profileWineryPanelIsOpen: false,
      wineryProfileModal: false,
    }
  },
  async mounted() {

    // Map info window.
    this.mapInfoWindow = new InfoWindow()

    // We create our own backdrop so that it's behind the modal.
    this.wineryProfileModal = new Modal(this.$refs['modal-winery-profile'], {
      backdrop: false,
    })

    // Listen for our custom event to open the winery profile panel.
    window.addEventListener('openProfile', (e) => {
      const wineryId = e.detail.wineryId

      const winery = this.wineries.find(winery => winery.id == wineryId)
      if (winery) {
        this.selectProfileWinery(winery)
      }
    })
  },
  methods: {
    selectProfileWinery(winery) {
      this.profileWinery = winery

      // Depending on the screen size, either open the winery profile 
      // modal or slide-out panel.
      if (window.innerWidth < 1200) {
        this.openWineryProfileModal()
      } else {
        this.openProfileWineryPanel()
      }

      // Open info window.
      const mapMarker = this.mapMarkers.find(marker => {

        // Additional location?
        if (winery.wineryId) {
          return marker.winery.wineryId == winery.wineryId

        // ... otherwise, main winery.
        } else {
          return marker.winery.id == winery.id
        }
      })

      if (mapMarker) {
        this.mapInfoWindow.close()
        this.mapInfoWindow.setContent(
          '<div class="map-ui-info-window">' + 
            '<b>' + winery.name + '</b><br>' + 
            winery.address + '<br>' + 
            winery.city + ', ' + winery.state + ' ' + winery.postalCode + '<br>' + 
            '<button type="button" onclick="window.pawine.openProfile(' + winery.id + ')">View Profile</button>' + 
          '</div>'
        )
        this.mapInfoWindow.open(mapMarker.marker.map, mapMarker.marker)
      }
    },
    clearProfileWinery() {
      this.profileWinery = {}
      this.closeProfileWineryPanel()
    },
    openProfileWineryPanel() {
      this.profileWineryPanelIsOpen = true
    },
    closeProfileWineryPanel() {
      this.profileWineryPanelIsOpen = false
    },
    openWineryProfileModal() {
      this.wineryProfileModal.show()

      this.$refs['modal-winery-profile-backdrop'].classList.add('show')
      this.$refs['modal-winery-profile-backdrop'].classList.remove('pe-none')
    },
    closeWineryProfileModal() {
      this.wineryProfileModal.hide()

      this.$refs['modal-winery-profile-backdrop'].classList.remove('show')
      this.$refs['modal-winery-profile-backdrop'].classList.add('pe-none')
    },
    async getPostalCodeCoords(postalCode) {
      this.isGeolocating = true
      this.searchLocation.postalCode = null
      this.searchLocation.latitude = null
      this.searchLocation.longitude = null

      try {

        // Get the latitude/longitude coordinates of the provided postal code
        // from geocod.io
        // @see https://www.geocod.io/docs/?shell#single-address
        const resp = await fetch('https://api.geocod.io/v1.7/geocode?' + new URLSearchParams({
          api_key: process.env.MIX_GEOCODIO_API_KEY,
          q: postalCode,
          limit: 1,
        }))

        const json = await resp.json()

        if (json.results && json.results[0]) {
          this.searchLocation.postalCode = postalCode
          this.searchLocation.latitude = json.results[0].location.lat
          this.searchLocation.longitude = json.results[0].location.lng
          this.isGeolocating = false

          this.filteredWineries = this.filterWineries()

        } else {
          this.isGeolocating = false

          swal('', 'No results were found from the submitted ZIP Code.')
        }

      } catch (error) {
        console.error(error)

        this.isGeolocating = false

        swal('', 'An unexpected error occurred.')
      }
    },
    degreesToRadians(degrees) {
      return degrees * (Math.PI / 180)
    },
    radiansToDegrees(radians) {
      return radians * (180 / Math.PI)
    },
    async getUserCoords() {
      this.isGeolocating = true

      try {
        const position = await this.geolocate()

        this.userCoords.latitude = position.coords.latitude
        this.userCoords.longitude = position.coords.longitude

        this.isGeolocating = false

      } catch (error) {
        console.error(error)

        // let errorMsg

        // switch(error.code) {
        //   case error.PERMISSION_DENIED:
        //     errorMsg = 'You denied the request for geolocation.'
        //     break
        //   case error.POSITION_UNAVAILABLE:
        //     errorMsg = 'Location information is unavailable.'
        //     break
        //   case error.TIMEOUT:
        //     errorMsg = 'The request to get your location timed out.'
        //     break
        //   case error.UNKNOWN_ERROR:
        //     errorMsg = 'An unknown error occurred.'
        //     break
        // }

        this.isGeolocating = false
      }
    },
    geolocate() {
      return new Promise((resolve, reject) => 
        navigator.geolocation.getCurrentPosition(resolve, reject, {})
      )
    },
  }
}
  